/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from 'react-router-dom';
import { useSocketListener } from 'hooks';
import { useSocketContext } from 'contexts';
import { Stream, StreamState } from 'interfaces/stream';
import { useCookies } from 'react-cookie';


export const useEventChanges: any = ({setStreams, streams}: {setStreams: React.Dispatch<React.SetStateAction<Stream[]>>, streams: Stream[]}) => {
  const [cookies] = useCookies();

  const { language } = cookies;
  const { eventSocket: socket } = useSocketContext();
  const onConnect = () => {
    console.info(
      `%cEvent socket connected`,
      `color: #06c16a; font-weight: bold;`,
    );

    socket.emit('new_session_instance');
  };

  const onChange = () => {
    navigate('/home');
  };

	const streamChange = (data: Stream & { streamId: string, 
    thumbnail: { language: string, text: string }[]
  }) => {
		const targetId = data.streamId
		const targetStream = streams.find(stream => stream.id === targetId)
		if(targetStream){
      const [protocol, host, eventId, path, image] = targetStream.thumbnail.split('/').filter(i => i)
			targetStream.state = data.state
      const thumbNail = data.thumbnail.find(thumbnail => thumbnail.language === language)
      if(thumbNail){
        targetStream.thumbnail = `${protocol}//${host}/${thumbNail.text}`
      }
		}
		setStreams([...streams])
	}
  const navigate = useNavigate();
  useSocketListener(socket, 'connected', onConnect);
  useSocketListener(socket, 'onchange', onChange);
  useSocketListener(socket, 'stream_change', streamChange);


};
